import { vsName as menuServiceName } from '../../../menu/provider/MenuService'

Controller.$inject = ['userServer', '$state', 'userProfile', '$rootScope', 'applicationInfo', menuServiceName]
function Controller(userServer, $state, userProfile, $rootScope, applicationInfo, menuService) {
  var vm = this

  vm.RememberMe = false
  vm.Username = ''
  vm.Password = ''
  vm.Login = Login
  vm.hasAuthenticationProvider = hasAuthenticationProvider
  vm.authProviderCount = applicationInfo.appInfo.AuthenticationProviders.length

  function hasAuthenticationProvider(name) {
    return applicationInfo.hasAuthenticationProvider(name)
  }

  function Login() {
    userServer
      .login(vm.Username, vm.Password, vm.RememberMe)
      .then(function (profile) {
        vm.Error = ''

        userProfile.initialize(profile)
        menuService.setProfile(userProfile)

        var targetState = vm.returnState

        if (targetState) {
          $state.go(targetState.name, targetState.params)
        }
        else {
          $state.go('findPage')
        }
      })
      .catch(function (errorMessage) {
        vm.Password = ''
        vm.Error = errorMessage.message
      })
  }
}

export default Controller